import { services } from './services'
import { validators } from './validators'

export const checksObj = {
  ...services,
  ...validators,
}
